var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33961_146880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6169 9.00004L9.00398 5.3871L5.39105 9.00004L9.00398 12.613L12.6169 9.00004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.578125 7.79569L7.79788 0.575934L7.79519 0.573242L7.80057 0.573242L7.8039 0.569916H10.2125L10.2065 0.575934L17.4279 7.79735L17.4297 7.79558V10.2077L17.4279 10.206L10.2082 17.4257L10.2125 17.4301H7.79519L7.79954 17.4257L0.578125 10.2043V7.79569ZM1.78244 9L9.00219 1.78025L16.2236 9.00166L9.00385 16.2214L1.78244 9Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33961_146880"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTier);
export default __webpack_public_path__ + "static/media/tier.4684e0e833d619d340dec8b8a0b7a767.svg";
export { ForwardRef as ReactComponent };